const normalizeUrl = (url) => {
  url = url.trim();
  return url;
};
export {
  normalizeUrl
};
